/*
 * @Name 开发环境配置项
 */
/* eslint-disable */
let wcm_domain_url = '//r.huaweistatic.com'
var contextPath = wcm_domain_url + '/s///{wcm_url_content}/lst/'
let imageDomain = '{wcm_domain_url_wcm}' // 此变量主要用于图片显示，对应不同的wcm静态资源服务

module.exports = {
    contextPath: contextPath,
    domainUrl: wcm_domain_url,
    imageDomain: imageDomain,
    MsaGatewayAddress: '//eventsgo.huawei.com/eventsgo/gateway/'
}
